import {
    AuthenticationMethodsPolicy,
    EmailAuthenticationMethodConfiguration,
    MicrosoftAuthenticatorAuthenticationMethodConfiguration,
} from '@microsoft/microsoft-graph-types-beta';
import { createAction, props } from '@ngrx/store';

export const loadAuthenticationMethodsPolicies = createAction(
    '[Graph/Authentication Methods Policies] Load Authentication Methods Policies',
    props<{ _tenant: string }>(),
);

export const loadAuthenticationMethodsPoliciesSuccess = createAction(
    '[Graph/Authentication Methods Policies] Load Authentication Methods Policies Success',
    props<{
        _tenant: string;
        policy: AuthenticationMethodsPolicy;
    }>(),
);

export const loadAuthenticationMethodsPoliciesFailure = createAction(
    '[Graph/Authentication Methods Policies] Load Authentication Methods Policies Failure',
    props<{ _tenant: string; error: any }>(),
);

export const updateAuthenticationMethodPolicyConfig = createAction(
    '[Graph/Authentication Methods Policies] Update Authentication Method Config',
    props<{
        _tenant: string;
        policy: EmailAuthenticationMethodConfiguration | MicrosoftAuthenticatorAuthenticationMethodConfiguration;
    }>(),
);

export const updateAuthenticationMethodPolicyConfigSuccess = createAction(
    '[Graph/Authentication Methods Policies] Update Authentication Method Config Success',
    props<{ _tenant: string; policy: EmailAuthenticationMethodConfiguration }>(),
);

export const updateAuthenticationMethodPolicyConfigFailure = createAction(
    '[Graph/Authentication Methods Policies] Update Authentication Method Config Failure',
    props<{ _tenant: string; error: any }>(),
);
